import circle from "./modules/circle";
import linearAnimations from "./modules/linearAnimations";
import send from "./modules/send";
import validate from "./modules/validate";

window.addEventListener("load", () => {
  gsap.registerPlugin(ScrollToPlugin);
  gsap.registerPlugin(ScrollTrigger);
  const scrollButton = document.querySelector('.training__btn');

  scrollButton.addEventListener('click', () => {
    gsap.to(window, { duration: 1, scrollTo: "#form" });
  })
  window.innerWidth > 991 ? circle() : null

  gsap.to(".training__descr span", {
    scrollTrigger: {
      trigger: '.training__descr',
      start: 'top 90%',
      end: 'bottom 50%',
      scrub: 2
    },
    ease: "power1.out",
    backgroundPositionX: '-100%'
  })

  gsap.to('.preloader', {
    duration: 1,
    autoAlpha: 0,
    onComplete: () => {
    }
  })

  linearAnimations();

  const btn = document.querySelector('.projects__btn'),
    container = document.querySelector('.projects__hidden');

  let toggleBlock = gsap.to(container, {
    height: 'auto',
    paused: true,
    autoAlpha: 1,
    duration: 2,
    ease: 'power1.out'
  })

  // btn.addEventListener('click', () => {
  //     btn.classList.toggle('open');
  //     container.classList.toggle('show');
  //     container.classList.contains('show') ? (toggleBlock.play() && (btn.textContent =`BACK`) ) : (toggleBlock.reverse() && gsap.to(window, { duration: 3, scrollTo: ".projects__list" }) && (btn.textContent =`LOAD MORE`));
  // })
  btn.addEventListener('click', () => {
    btn.classList.toggle('hidden');
    toggleBlock.play();

  })

  validate('input[name="name"]', 'input[name="phone"]', 'input[name="email"]');
  send('#form', 'input[name="name"]', 'input[name="phone"]', 'input[name="email"]', "/mailer/mail-footer.php");
})